import type { FaireProductEntity } from "../../entity_types/product";

export const p_zdbsjva99c: FaireProductEntity = {
  token: "p_zdbsjva99c",
  type: "product",
  name: "C.C Play Ball Letter Stripe Pattern Trucker Cap",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl: "https://cdn.faire.com/fastly/7da7405cbbdc1fc1282c6593fa5d305903625a43904710fd5eb37717a20fed33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/460146cb18113caea65bc1710803eaa91c68d4fb042f44a4c5e3b38850d3cafa.jpeg",
    "https://cdn.faire.com/fastly/6ed8e53ead6b36da14eed0b5cb927a7a3e9b5de01fdd0d2f6c7b112b3de28f71.jpeg"
  ],
  priceDollars: 8.5,
  description: "C.C Play Ball Letter Stripe Pattern Two Tone Trucker Hat Baseball Cap\n100% Cotton\nCircumference 22.5\"\nOne Size\nMade in Vietnam",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:35.229Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
